import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule, DxToastModule } from 'devextreme-angular';
import { CommonModule } from '@angular/common';
import { LabelMode } from 'devextreme/common';
 import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
 import { CtlGasBirimDosyaPlanAramaComponent } from './ctl-gas-birim-dosya-plan-arama/ctl-gas-birim-dosya-plan-arama.component';
import { CtlGasBirimDosyaPlanService } from './ctl-gas-birim-dosya-plan.service';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';

@Component({
  selector: 'dk-ctl-gas-birim-dosya-plan',
  standalone: true,
  imports: [DxButtonModule,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxToastModule,
    CtlSablonComponent,
    CtlGasBirimDosyaPlanAramaComponent],
  providers:[CtlGasBirimDosyaPlanService],

  templateUrl: './ctl-gas-birim-dosya-plan.component.html',
  styleUrls: ['./ctl-gas-birim-dosya-plan.component.scss'],
})
export class CtlGasBirimDosyaPlanComponent implements OnChanges,OnInit {

  @Input() labelText = "";
  @Input() labelMode: LabelMode = null;
  public crudPopupVisible = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public title!: string;
public isFirst = true;
  public control!: any;
  controlName = "GasBirimDosya";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  @Input() code!: any;
  @Input() birim!: number;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: CtlGasBirimDosyaPlanService, private utilsService: UtilsService, private ortakService: OrtakService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['birim']) {
      if (this.birim == null) this.showAction = false
      else {
        this.showAction = true
        this.service.setParams(this.birim,this.isReadOnly,this.isBindCheck)
      }
    }
    if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.birim,this.isReadOnly,this.isBindCheck)
      }
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if (!this.birim) {
      this.toastMessage = "Birim kodu alınamadı"
      this.showAction = false
    }
        this.service.setParams(this.birim,this.isReadOnly,this.isBindCheck)
  }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }

  searchClick() {
    if (this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (this.showAction) {
      if (e === '' || e === null) this.clear();
      else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
    }
    else this.toastVisible = true
  }

  getData(code: any, isSetData?: boolean) {

    this.data = this.service.getData((code), this.birim,this.control,this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0]?.DosyaPlanAd;
        this.code = result[0]?.DosyaPlanKod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.DosyaPlanKod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}
